import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import de from '@angular/common/locales/de';
import fr from '@angular/common/locales/fr';
import es from '@angular/common/locales/es';
import it from '@angular/common/locales/it';
import pt from '@angular/common/locales/pt';

export const registerLocale = (type: string): void => {
  const languages = [
    { type: 'de', locale: de },
    { type: 'en', locale: en },
    { type: 'fr', locale: fr },
    { type: 'it', locale: it },
    { type: 'es', locale: es },
    { type: 'pt', locale: pt },
  ];
  const index = languages.findIndex((item) => item.type === type);

  registerLocaleData(languages[index].locale);
};
